import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import styled from 'foundations-theming/utils';
import isNumber from 'transmute/isNumber';
import once from 'transmute/once';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const isValidDateWithoutYear = date => {
  return !!date && typeof date === 'object' && 'month' in date && isNumber(date.month) && 'date' in date && isNumber(date.date);
};
const AnniversaryInputWrapper = styled.div.withConfig({
  displayName: "AnniversaryDateInput__AnniversaryInputWrapper",
  componentId: "oxvvsb-0"
})(["display:flex;flex-direction:row;"]);
const getMonthOptions = once(() => Array.from({
  length: 12
}, (_, i) => ({
  value: i,
  text: I18n.text(`months.${i + 1}`)
})));
const getMonthLength = month => {
  switch (month) {
    case 0: //January
    case 2: //March
    case 4: //May
    case 6: //July
    case 7: //August
    case 9: //October
    case 11:
      //December
      return 31;
    case 3: //April
    case 5: //June
    case 8: //September
    case 10:
      //November
      return 30;
    case 1:
      //February
      return 28;
    // Sending Feb 29 to the BE does not behave as expected
    default:
      return 0;
  }
};
const getDateOptionsArray = month => Array.from({
  length: getMonthLength(month)
}, (_, i) => ({
  value: i + 1,
  text: (i + 1).toString()
}));
const AnniversaryDateInput = props => {
  const {
    onBlur,
    onChange,
    value,
    inputUse
  } = props;
  const onChangeMonth = evt => {
    const newMonth = evt.target.value;
    const maxDate = getMonthLength(newMonth);
    const dateExceedsMax = (value === null || value === void 0 ? void 0 : value.date) && (value === null || value === void 0 ? void 0 : value.date) > maxDate;
    onChange(Object.assign({}, value, {
      month: newMonth,
      date: dateExceedsMax ? maxDate : value === null || value === void 0 ? void 0 : value.date
    }));
  };
  const onChangeDate = evt => {
    onChange(Object.assign({}, value, {
      date: evt.target.value
    }));
  };
  const onOpenChange = evt => {
    if (evt.target.value === false && onBlur) {
      onBlur();
    }
  };
  return /*#__PURE__*/_jsxs(AnniversaryInputWrapper, {
    children: [/*#__PURE__*/_jsx(Select, {
      options: getMonthOptions(),
      value: value === null || value === void 0 ? void 0 : value.month,
      onChange: onChangeMonth,
      onOpenChange: onOpenChange,
      buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
    }), /*#__PURE__*/_jsx(Select, {
      options: getDateOptionsArray(value === null || value === void 0 ? void 0 : value.month),
      value: value === null || value === void 0 ? void 0 : value.date,
      onChange: onChangeDate,
      onOpenChange: onOpenChange,
      buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
    })]
  });
};
export default AnniversaryDateInput;